<app-base-modal
  class="w-150 pt-10"
  [iconPath]="'circled-checkmark'"
  [titleTranslationKey]="buildTranslationKey('invitationSent') | translate"
  [descriptionTranslationKey]="buildTranslationKey('invitationSentDescription') | translate"
  [footerTemplate]="footer"
></app-base-modal>

<ng-template #footer>
  <div class="flex justify-between w-full items-center">
    <app-powered-by></app-powered-by>

    <app-new-button [type]="'primary'" [saveButtonSizeDuringLoading]="true" (click)="closeModal()">
      {{ buildTranslationKey('gotIt') | translate }}
    </app-new-button>
  </div>
</ng-template>
